exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".shell-icon[data-v-e6053466]{display:inline-block;width:1em;height:1em;flex-shrink:0;vertical-align:middle}", ""]);

